import { render, staticRenderFns } from "./student-tree-chart.vue?vue&type=template&id=143cb2b5&scoped=true&"
import script from "./student-tree-chart.ts?vue&type=script&lang=ts&"
export * from "./student-tree-chart.ts?vue&type=script&lang=ts&"
import style0 from "./student-tree-chart.scss?vue&type=style&index=0&id=143cb2b5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143cb2b5",
  null
  
)

export default component.exports